import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, X } from "@phosphor-icons/react";
import { toast } from "sonner";

const SEV_COLOR = {
  danger: "#dc2626", warning: "#d97706", info: "var(--text-dim)",
};

export default function NotificationsPanel() {
  const [items, setItems] = useState([]);
  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch (_e) { /* silent */ }
  };
  useEffect(() => { load(); }, []);

  const dismiss = async (id) => {
    setItems(items.filter(i => i.id !== id));
    try { await api.delete(`/notifications/${encodeURIComponent(id)}`); }
    catch (_e) { toast.error("Failed"); load(); }
  };

  const clearAll = async () => {
    setItems([]);
    try { await api.delete(`/notifications`); }
    catch (_e) { toast.error("Failed"); load(); }
  };

  return (
    <div id="notifications-section" className="space-y-6" data-testid="notifications-tab">
      <div className="flex items-center gap-2">
        <Bell size={18} weight="bold" />
        <h2 className="title-xl text-2xl">Notifications</h2>
        <span className="label ml-auto">{items.length}</span>
        {items.length > 0 && (
          <button onClick={clearAll}
            className="text-xs px-2 py-1 rounded hover:opacity-70"
            style={{ background: "transparent", border: "none", color: "var(--text-dim)" }}
            data-testid="notif-clear-all">
            Clear all
          </button>
        )}
      </div>
      {items.length === 0 ? (
        <div className="panel p-10 text-center label">You're all caught up</div>
      ) : (
        <div className="space-y-2">
          {items.map(n => (
            <div key={n.id} data-testid={`notif-row-${n.id}`}
              className="hair p-3 flex items-start gap-3">
              <span className="mt-1 shrink-0 w-2 h-2 rounded-full"
                style={{ background: SEV_COLOR[n.severity] || SEV_COLOR.info }} />
              <div className="flex-1 min-w-0">
                <p className="font-medium" style={{ overflowWrap: "anywhere" }}>{n.title}</p>
                {n.subtitle && <p className="text-xs mt-0.5" style={{ color: "var(--text-dim)", overflowWrap: "anywhere" }}>{n.subtitle}</p>}
              </div>
              <button onClick={() => dismiss(n.id)}
                className="text-xs p-1 rounded hover:opacity-70"
                style={{ background: "transparent", border: "none", color: "var(--text-dim)" }}
                data-testid={`notif-row-dismiss-${n.id}`}
                title="Dismiss">
                <X size={12} weight="bold" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
